import * as React from 'react';
import Svg, { SvgProps, Path } from 'react-native-svg';

const ColumnsIcon12 = (props: SvgProps) => <Svg
  width="14"
  height="12"
  viewBox="0 0 14 12"
  fill="none"
  {...props}
>
  <Path
    d="M5 1V11M9 1V11M1.75 11H12.25C12.6642 11 13 10.6642 13 10.25V1.75C13 1.33579 12.6642 1 12.25 1H1.75C1.33579 1 1 1.33579 1 1.75V10.25C1 10.6642 1.33579 11 1.75 11Z"
    stroke="#0058AD"
    strokeLinecap="round"
    strokeLinejoin="round"
  />
</Svg>;

export default ColumnsIcon12;
